import styled from 'styled-components'
import { Breakpoints, Type, Colors } from '@/styles'

export const PodcastTranscriptPageComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

/* --------------------
Typography
-------------------- */

export const Title = styled.h2`
  ${Type.header2};
  color: ${({ color }) => (color ? color : Colors.text)};
  margin-bottom: 10px;
  @media (min-width: ${Breakpoints.desktop}) {
    margin-bottom: 35px;
    max-width: 674px;
  }
`

/* --------------------
Content
-------------------- */

export const ContentWrapper = styled.div`
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;
  @media (min-width: ${Breakpoints.tablet}) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 20px;
  }
  @media (min-width: ${Breakpoints.desktop}) {
    padding-top: 120px;
    padding-bottom: 120px;
  }
`

export const ContentMain = styled.div`
  @media (min-width: ${Breakpoints.tablet}) {
    grid-column: 1 / span 7;
    padding-top: 12px;
    align-self: start;
  }
`

export const ContentSidebar = styled.div`
  @media (min-width: ${Breakpoints.tablet}) {
    grid-column: 10 / span 3;
    align-self: start;
    margin-top: 20px;
  }
`

/* --------------------
Transcript
-------------------- */

export const Transcript = styled.div`
  ${Type.body40};
  margin-bottom: 0;
  color: ${Colors.navy};
`
